// extracted by mini-css-extract-plugin
export var section = "CommentSection-module--section--1P1PD";
export var title = "CommentSection-module--title--2c3ub";
export var error = "CommentSection-module--error--2mh-N";